import { render, staticRenderFns } from "./SticksIngredients.vue?vue&type=template&id=63b345c2&"
import script from "./SticksIngredients.vue?vue&type=script&lang=js&"
export * from "./SticksIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports